import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-manage-index",
    templateUrl: "./manage-index.component.html",
    styleUrl: "./manage-index.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageIndexComponent implements OnInit {
    constructor(private readonly api: PerFormaAPIService) {}

    loading = true;
    Documents: number;
    IndexedDocuments: number;
    Reindexing = true;
    PercentComplete = 0;
    Status = "";

    async ngOnInit() {
        try {
            await this.GetIndexInfo();
        } finally {
            this.loading = false;

            setInterval(async () => {
                await this.GetIndexInfo();
            }, 5000);
        }
    }

    GetIndexInfo = async () => {
        const info = await lastValueFrom(this.api.postApiConfigureIndexInfo());

        this.Documents = info.Documents;
        this.IndexedDocuments = info.IndexedDocuments;
        this.Reindexing = info.Reindexing;
        this.Status = info.Status;
        this.PercentComplete = info.PercentComplete;
    };

    RebuildIndex = async () => {
        if (
            this.Reindexing ||
            !confirm(
                "Are you sure you want to do this? This may take several minutes or even hours depending on the number of documents."
            )
        )
            return;

        this.Reindexing = true;

        // start the reindex process
        await lastValueFrom(this.api.postApiConfigureIndexRebuild());
    };
}
